<template>
  <section class="invoice-preview-wrapper">
    <b-overlay
      :show="isBusyTable"
      rounded="sm"
    >
      <!-- Si no hay error en cargando la tabla -->
      <div v-if="!errorContent.table">
        <!-- Lista de datos de facturación -->
        <div
          v-if="!showForm"
          no-body
          class="mb-0"
        >
          <div>
            <!-- Table Top -->
            <div class="m-2">
              <!-- Botón para nuevo registro y buscador -->
              <b-row>
                <!-- Nuevo registro -->
                <b-col
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <b-button
                    variant="primary"
                    @click="showForm = true; itemSelected = null"
                  >
                    Agregar
                  </b-button>
                </b-col>
                <!-- Buscador -->
                <!-- <b-col
                  cols="12"
                  md="6"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon
                          :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                          :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                          @click="searchQuery != '' ? searchQuery = '' : ''"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="searchQuery"
                        placeholder="Buscar por alias de registro"
                      />
                    </b-input-group>
                  </div>
                </b-col> -->
              </b-row>
            </div>
            <!-- Table -->
            <b-table
              ref="refDataListTable"
              :fields="tableColumns"
              :items="fetchData"
              :sort-desc.sync="isSortDirDesc"
              :sort-by.sync="sortBy"
              responsive
              striped
              show-empty
              primary-key="id"
              class="position-relative"
              empty-text="Aún no ha configurado sus datos de facturación."
            >
              <template #cell(id)="data">
                <div class="text-nowrap text-center">
                  <b-link
                    class="font-weight-bold text-secondary"
                    @click="showForm = true; itemSelected = data.item.id"
                  >
                    <feather-icon
                      :id="`curso-row-${data.item.id}-edit-icon`"
                      icon="EditIcon"
                      class="cursor-pointer"
                      size="16"
                      :class="data.item.activo ? 'mx-1' : 'mr-1'"
                    />
                  </b-link>
                  <b-tooltip
                    title="Editar registro"
                    placement="bottom"
                    :target="`curso-row-${data.item.id}-edit-icon`"
                  />
                  <span>{{ data.item.id }}</span>
                </div>
              </template>
            </b-table>
          </div>
          <!-- Table's footer & pagination -->
          <div class="mx-2 mb-2">
            <b-row>
              <!-- Leyenda de cuantos elementos se muestran -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >

                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>
            </b-row>
          </div>
        </div>

      </div>
      <!-- Si hay algún error -->
      <div v-else>
        <b-alert
          variant="danger"
          show
          class="mb-0 text-center"
        >
          <div class="alert-body">
            <span>Ocurrió algo inesperado, por favor <b>intente nuevamente</b></span>
          </div>
        </b-alert>
      </div>
    </b-overlay>
    <!-- MODALES - Agregar datos de Facturacion -->
    <b-modal
      id="mdlnewdf"
      v-model="showForm"
      size="xl"
      modal-class="modal-dark"
      centered
      title="Agregar datos de Facturación"
      no-close-on-backdrop
      hide-footer
      no-body
      @hide="showForm = false; itemSelected = null"
    >
      <!-- <b-container> -->
      <!-- Formulario -->
      <transition name="fade">
        <form-datos-facturacion
          v-if="showForm"
          :id="itemSelected"
          :external-user="externalUser"
          @hide-form="showForm = false; itemSelected = null"
          @reload-data="showForm = false; itemSelected = null; refetchData(true)"
        />
      </transition>
      <!-- </b-container> -->
    </b-modal>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  // BFormInput,
  BTable,
  BPagination,
  BTooltip,
  BLink,
  // BInputGroup,
  BButton,
  // BInputGroupPrepend,
  BOverlay,
  BAlert,
  // BContainer,
  // BCard,
} from 'bootstrap-vue'
import {
  ref, computed, onMounted, watch,
} from '@vue/composition-api'
import { isObject, isEmptyObject } from '@core/utils/utils'
import { configTableFactura } from '@/views/campus/cuenta/useDatosFacturacion'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import { rolesActions } from '@core/mixins/account-data/roles'
import store from '@/store'
import FormDatosFacturacion from './FormDatosFacturacion.vue'

export default {
  components: {
    BRow,
    BCol,
    // BFormInput,
    BTable,
    BTooltip,
    BLink,
    BButton,
    // BInputGroup,
    // BInputGroupPrepend,
    BPagination,
    BOverlay,
    BAlert,
    // BContainer,
    FormDatosFacturacion,
  },
  mixins: [rolesActions],
  props: {
    externalUser: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const showForm = ref(false)
    const itemSelected = ref(null)
    const errorContent = ref({ table: false })
    const { tableColumns, configRequest } = configTableFactura()
    const userRole = computed(() => store.state.cuenta.rolSelected)
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()

    //* On mounted
    onMounted(() => {
      if (isObject(props.externalUser) && !isEmptyObject(props.externalUser) && props.externalUser.value && props.externalUser.tipo) {
        configRequest.value.wsType = (props.externalUser.tipo === 'matricula') ? 'wsfactura' : 'wsinscripcion'
        configRequest.value.wsParams[props.externalUser.tipo] = props.externalUser.value
        configRequest.value.wsParams.action = (props.externalUser.tipo === 'matricula') ? 2 : 20
        if (configRequest.value.wsType === 'wsinscripcion') {
          delete configRequest.value.wsParams.token
        }
      }

      // siempre mandar el rol
      configRequest.value.wsParams.rol = userRole.value.id
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
    })

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      configRequest,

      // Data
      itemSelected,
      userRole,

      // Flag
      showForm,

      // Loader
      isBusyTable,

      // Error
      errorContent,
    }
  },
}
</script>
